import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../panel/Panel";
//import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../actions/panel";
import { ProjectOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../common/EntityLoader";

const Title = ({entity}) => <span>
    <ProjectOutlined /> {!!entity ? entity.name : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <span>{entityId}</span>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`projects:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({projectId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#3ed115"
        id={`projects:${projectId}:edit`}
        title={
            <EntityLoader entityId={projectId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={projectId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
